import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { fetchErpLogs } from 'utils/api/logsApi'
import { getColumns } from './utils'
import { calculateOffset } from 'utils/helpers/pagination'

const ErpLogTable = () => {
  const [logResponse, setLogResponse] = useState<any>({})
  const [page, setPage] = useState<number>(0)

  const { search } = useLocation()
  const { getQuery } = useQuery()

  const columns = useMemo(() => getColumns(page), [page])

  // To get ERP Log data
  const getLogs = async () => {
    try {
      const { data } = await fetchErpLogs({
        limit: getQuery('limit') || 10,
        page: getQuery('page') || 1,
      })
      setPage(calculateOffset(data))
      setLogResponse(data)
    } catch (error) {
      setLogResponse({ docs: [] })
    }
  }

  useEffect(() => {
    getLogs()
  }, [search])

  return (
    <>
      <div className="title">ERP API</div>
      <DataTable columns={columns} rows={logResponse?.docs} identifier="_id" />

      {/* Table Pagination */}
      <DataTablePagination
        currentPage={logResponse?.page}
        totalPages={logResponse?.totalPages}
        hasNextPage={logResponse?.hasNextPage}
        hasPrevPage={logResponse?.hasPrevPage}
        limit={logResponse?.limit}
        nextPage={logResponse?.nextPage}
        prevPage={logResponse?.prevPage}
      />
    </>
  )
}

export default ErpLogTable
